import AdaptiveCriticalImage from "../../atoms/AdaptiveCriticalImage";
// JSON Keys for Download CTA
// isAdaptive: true, // For both appstore and playstore buttons
// hasAppStore: true, // For appstore button only
// hasPlayStore: true, // For playstore button only

export default function HeroWithDownload({ data }) {
  const AppStore = () => {
    return (
      <a
        href="https://apps.apple.com/us/app/setmore-appointments-appointment-scheduling-app/id665859578"
        className="--app-store lg:mr-3"
        target="_blank"
        rel="noopener noreferrer"
      >
        <img
          src="https://assets.setmore.com/website/v2/images/icons/appstore-badge-2x.png"
          alt="apple app store icon"
          loading="lazy"
          width="157"
          height="48"
        />
      </a>
    );
  };
  const PlayStore = () => {
    return (
      <a
        href="https://play.google.com/store/apps/details?id=com.adaptavant.setmore&hl=en"
        className="--play-store"
        target="_blank"
        rel="noopener noreferrer"
      >
        <img
          src="https://assets.setmore.com/website/v2/images/features/features-android-app/google-play-badge.png"
          alt="Google Play Icon"
          loading="lazy"
          width="157"
          height="48"
        />
      </a>
    );
  };

  return (
    <section
      className={`container grid--default hero--default lg:pb-10 md:pb-5 has-align-top`}
    >
      <article className={`lg:maxw-lg text-left`}>
        <h1 className="text-xl lg:pt-5">{data.title}</h1>
        {data.hasOwnProperty("desc") &&
          data.desc.map((item, index) => {
            return (
              <p
                className="lg:maxw-md lg:mt-2 lg:mb-2"
                key={index}
                dangerouslySetInnerHTML={{ __html: item }}
              />
            );
          })}
        {data.cta.hasOwnProperty("isAdaptive") &&
          data.cta.isAdaptive === true && (
            <div className="lg:mt-4 md:mt-2">
              <AppStore />
              <PlayStore />
            </div>
          )}
        {data.cta.hasOwnProperty("hasAppStore") &&
          data.cta.hasAppStore === true && (
            <div className="lg:mt-4 md:mt-2">
              <AppStore />
            </div>
          )}
        {data.cta.hasOwnProperty("hasPlayStore") &&
          data.cta.hasPlayStore === true && (
            <div className="lg:mt-4 md:mt-2">
              <PlayStore />
            </div>
          )}
      </article>{" "}
      <figure className="md:mt-5 lg:maxw-lg">
        <picture>
          <AdaptiveCriticalImage
            src={data.img.src}
            alt={data.img.alt}
            mobile={data.img.prefixes.mobile}
            dpi={data.img.prefixes.dpi}
            dimensions={data.img.dimensions}
            className="img-fit"
          />
        </picture>
      </figure>
    </section>
  );
}
